// extracted by mini-css-extract-plugin
export var textContainer = "infoText-module--textContainer--s5WiV";
export var title = "infoText-module--title--1opXh";
export var body = "infoText-module--body--ZxBVX";
export var iconContainer = "infoText-module--iconContainer--2lpv0";